"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vi_VN = _interopRequireDefault(require("../../date-picker/locale/vi_VN"));
var _default = exports.default = _vi_VN.default;